<template>
  <Transition>

    <div class="organizer-modal" v-if="isVisible">
      <div class="organizer-modal-content">
        <button class="organizer-modal__close-btn" @click="$emit('close')">
          <i>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L13 13M1 13L13 1" stroke="#333333" stroke-width="1.5" />
            </svg>
          </i>
        </button>

        <div class="organizer-modal__wrap">
          <img :src="`/api/pis/v1/images/icons/${organizer.logo}`" alt="" class="organizer-modal__logo" />
          <div class="organizer-modal__info">
            <h2 class="organizer-modal__title">{{ organizer.title }}</h2>
            <!-- <p class="organizer-modal__short-name">{{ organizer.shortName }}</p> -->
            <p class="organizer-modal__description">{{ organizer.shortDesc }}</p>
          </div>
        </div>
        <a :href="organizer.link" target="_blank" class="organizer-modal__link-btn">Перейти к организатору</a>
      </div>
    </div>
  </Transition>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    organizerId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      organizer: {},
      isVisible: false
    };
  },
  methods: {
    fetchOrganizer() {
      const apiUrl = `/api/pis/v1/orgs/detailed_org/${this.organizerId}`;
      axios.get(apiUrl, {
        headers: {
          'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1'
        }
      })
        .then(response => {
          this.organizer = response.data;
          this.isVisible = true;
        })
        .catch(error => {
          console.error('Ошибка при получении данных об организаторе:', error);
        });
    }
  },
  mounted() {
    this.fetchOrganizer();
  }
};
</script>